import _JSXStyle from "styled-jsx/style";
import { colors, spacers, theme } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';

const Empty = _ref => {
  let {
    message,
    className,
    dataTest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["3788156646", [colors.grey700, theme.fonts, spacers.dp8, spacers.dp24]]]) + " " + (className || "")
  }, message, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3788156646",
    dynamic: [colors.grey700, theme.fonts, spacers.dp8, spacers.dp24]
  }, ["div.__jsx-style-dynamic-selector{color:".concat(colors.grey700, ";font-family:").concat(theme.fonts, ";font-size:13px;line-height:16px;padding-block:").concat(spacers.dp8, ";padding-inline:").concat(spacers.dp24, ";text-align:center;}")]));
};

Empty.propTypes = {
  dataTest: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  className: PropTypes.string
};
export { Empty };